import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'bootstrap/dist/css/bootstrap.min.css';

const Services = () => {
  const services = [
    {
      img: 'assets/img/service/service_img_1.jpg',
      title: 'IT & Software Development',
    },
    {
      img: 'assets/img/service/service_img_2.jpg',
      title: 'Mobile App Development',
    },
    {
      img: 'assets/img/service/service_img_3.jpg',
      title: 'Digital Marketing',
    },
    {
      img: 'assets/img/service/service_img_4.jpg',
      title: 'Artificial Intelligence (AI)',
    },
    {
      img: 'assets/img/service/service_img_1.jpg',
      title: 'Machine Learning (ML)',
    },
    {
      img: 'assets/img/service/service_img_2.jpg',
      title: 'Data Science & Analytics',
    },
    {
      img: 'assets/img/service/service_img_3.jpg',
      title: 'Cloud Infrastructure',
    },
    {
      img: 'assets/img/service/service_img_4.jpg',
      title: 'Cybersecurity Solutions',
    },
    {
      img: 'assets/img/service/service_img_1.jpg',
      title: 'DevOps & Automation',
    },
  ];

  return (
    <section
      className="position-relative bg-top-center overflow-hidden py-5"
      id="service-sec"
      style={{ backgroundImage: 'url(assets/img/bg/service_bg_1.jpg)', backgroundSize: 'cover' }}
    >
      <div className="container">
        <div className="text-center mb-5">
          <span className="sub-title d-block text-primary mb-2">Our Services</span>
          <h2 className="sec-title">Empowering Businesses Through Technology</h2>
          <p className="text-muted">
            Our expertise spans across core digital transformation areas — from software engineering<br />
            to data-driven decision-making and scalable cloud solutions.
          </p>
        </div>

        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          spaceBetween={30}
          navigation
          pagination={{ clickable: true }}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          breakpoints={{
            0: { slidesPerView: 1 },
            576: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            992: { slidesPerView: 2 },
            1200: { slidesPerView: 3 },
            1300: { slidesPerView: 4 },
          }}
        >
          {services.map((service, index) => (
            <SwiperSlide key={index}>
              <div className="card border-0 shadow h-100">
                <img
                  src={service.img}
                  alt={service.title}
                  className="card-img-top"
                  style={{ height: '180px', objectFit: 'cover' }}
                />
                <div className="card-body">
                  <h5 className="card-title">{service.title}</h5>
                  <p className="card-text">
                    We offer end-to-end {service.title.toLowerCase()} services tailored to help you stay competitive in the digital age.
                  </p>
                  <a href="/services" className="btn btn-outline-primary btn-sm">
                    Read More <i className="fa fa-arrow-right-long ms-1"></i>
                  </a>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Services;
